import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm ${className}`} data-id="element-122">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 pb-3 ${className}`} data-id="element-123">{children}</div>;
}
export function CardContent({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 pt-0 ${className}`} data-id="element-124">{children}</div>;
}